var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpageScreenshoter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b03ba9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#9e1f63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#521f63"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.16943,26.96616v46.06768h51.66113V26.96616H24.16943ZM68.42572,30.63915c.92328,0,1.67173.74841,1.67173,1.67169s-.74845,1.67169-1.67173,1.67169-1.67169-.74841-1.67169-1.67169.74845-1.67169,1.67169-1.67169ZM62.28108,30.63915c.92324,0,1.67169.74841,1.67169,1.67169s-.74845,1.67169-1.67169,1.67169-1.67169-.74841-1.67169-1.67169.74841-1.67169,1.67169-1.67169ZM30.38145,30.63915h20.96577c.92328,0,1.67169.74841,1.67169,1.67169s-.74841,1.67169-1.67169,1.67169h-20.96577c-.92328,0-1.67173-.74841-1.67173-1.67169s.74845-1.67169,1.67173-1.67169ZM71.29028,68.49355H28.70972v-30.46084h42.58056v30.46084Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.59506 54.38954 56.70339 54.38954 56.70339 46.97356 49.28805 46.97356 49.28805 43.08189 60.59506 43.08189 60.59506 54.38954"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.54014 63.44414 40.23281 63.44414 40.23281 52.13713 44.12448 52.13713 44.12448 59.55247 51.54014 59.55247 51.54014 63.44414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpageScreenshoter);
export default __webpack_public_path__ + "static/media/webpage-screenshoter.291732084da80bc8f2425dea4d12d4c5.svg";
export { ForwardRef as ReactComponent };